// selectable-item.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-selectable-item-template',
  templateUrl: './selectable-item-template.component.html',
  styleUrls: ['./selectable-item-template.component.scss'],
})
export class SelectableItemTemplateComponent {
  @Input() user: any;
  
  hasEmailMismatch(): boolean {
    if (this.user.providerData?.length > 0) {
      return this.user.providerData.some((p: any) => {
        if (p.email) {
          return p.email !== this.user.email;
        } else if (p.phoneNumber) {
          return p.phoneNumber !== this.user.phoneNumber;
        }
        return false;
      });
    }
    return false;
  }
}